import { Stack, Typography } from "@mui/material";
import { QuantityItem } from "../../../shared/ui";
import { calcTotalNomenclature } from "../../../../store/helpers/calcTotalNomenclature";
import { useShelvingStore } from "../../../../store";
import shallow from "zustand/shallow";
import { Width } from "../../../../store/types/store";

export const NomenklatureBlock = () => {
    const { shelving } = useShelvingStore(
        (state) => ({
            shelving: state.shelving,
        }),
        shallow
    );

    const widthes = Object.values(Width).filter((v) => !isNaN(Number(v)));
    const nomenklature = calcTotalNomenclature(shelving, widthes);

    return (
        <Stack gap={1}>
            <Typography color={"primary.main"} fontWeight={700}>
                ТЕКУЩИЙ НАБОР:
            </Typography>
            <Stack direction={"row"} gap={2.5}>
                <Stack gap={0.5}>
                    <Typography color={"primary.main"}>ГОРИЗОНТАЛЬ:</Typography>
                    <Stack gap={0.5}>
                        {widthes.map((width) => (
                            <QuantityItem
                                key={width}
                                value={nomenklature.horizontal[width as Width]}
                                units="шт."
                                label={`${width} мм`}
                            />
                        ))}
                    </Stack>
                </Stack>
                <Stack>
                    <Typography color={"primary.main"}>ВЕРТИКАЛЬ:</Typography>
                    <Stack gap={0.5}>
                        {widthes.slice(1).map((width) => (
                            <QuantityItem
                                key={width}
                                value={nomenklature.vertical[width as Width]}
                                units="шт."
                                label={`${width} мм`}
                            />
                        ))}
                    </Stack>
                </Stack>
                <Stack>
                    <Typography color={"primary.main"}>СОЕДИНИТЕЛЬ:</Typography>
                    <Stack gap={0.5}>
                        <QuantityItem value={nomenklature.connector} units="шт." label="СОЕДИНИТЕЛЬ" />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};
